module.exports = __webpack_public_path__ + "static/media/service-scenario-bg3.6a4df91d.png";